module.exports = __webpack_public_path__ + "img/fan_stop.75592ee8.svg";